
import EDCheckbox from '../../../../../../../../../BaseComponents/Checkboxes/EDCheckbox';
import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

interface IProps {
  showAvailable: boolean;
  showNotAvailable: boolean;
  setShowAvailable: (available: boolean) => void;
  setShowNotAvailable: (available: boolean) => void;
  showVisible: boolean;
  showNotVisible: boolean;
  setShowVisible: (visible: boolean) => void;
  setShowNotVisible: (visible: boolean) => void;
}

const useStyles = makeStyles()(
  (theme: Theme) =>
    ({
      container: {
        paddingLeft: theme.spacing(1),
        marginLeft: 40,
        marginRight: 40,
      },
    } as const)
);

/**
 * Filtreringsalternativ för analysutdelningsrutinen
 */
const AnalysUtdelningFiltering: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes } = useStyles();
  return (
    <div className={classes.container}>
      <div>
        <EDCheckbox
          label="Visa tillgängliga"
          checked={props.showAvailable}
          onCheck={props.setShowAvailable}
        />
      </div>
      <div>
        <EDCheckbox
          label="Visa 'ej tillgängliga'"
          checked={props.showNotAvailable}
          onCheck={props.setShowNotAvailable}
        />
      </div>
      <div>
        <EDCheckbox
          label="Visa synliga"
          checked={props.showVisible}
          onCheck={props.setShowVisible}
        />
      </div>
      <div>
        <EDCheckbox
          label="Visa 'ej synliga'"
          checked={props.showNotVisible}
          onCheck={props.setShowNotVisible}
        />
      </div>
    </div>
  );
};

export default AnalysUtdelningFiltering;
